export function formatPhone(phone?: string | null) {
  if (!phone) {
    return "";
  }
  const match = phone.match(/(\+?\d+)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`;
  }
  return phone;
}

export function formatPhoneE164(phone?: string) {
  if (!phone) {
    return "";
  }
  const p = phone.replace(/\D/g, "");
  if (p.length !== 10 && p.length !== 11) {
    throw new Error("Invalid phone number");
  }
  if (p.length === 11 && /^1/.test(p)) {
    return `+${p}`;
  }
  return `+1${p}`;
}

export function validNumber(mobile?: string) {
  if (!mobile) {
    return false;
  }
  const stripped = mobile.replace(/\D/g, "");
  return [10, 11].includes(stripped.length);
}
